const SAFE_ROOTS = [
  'book', 'bookings', 'coaches', 'class-categories', 'packages',
  'memberships', 'profile', 'contact', 'event',
];

export function isNativeNavigationPage(href: string) {
  const url = new URL(href, 'https://native.invalid');
  if (url.origin !== 'https://native.invalid') return false;
  if (url.pathname === '/book/return' || url.pathname.startsWith('/book/return/')) return false;
  return ['/auth/sign-in', '/auth/sign-up'].includes(url.pathname) || url.pathname === '/' || SAFE_ROOTS.includes(url.pathname.split('/')[1] ?? '');
}

export function nativeParentRoute(pathname: string) {
  if (pathname.startsWith('/event/') || pathname.startsWith('/auth/')) return '/';
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length > 1 && isNativeNavigationPage(pathname)) {
    return `/${segments.slice(0, -1).join('/')}`;
  }
  return '/';
}

export interface NativeNavigationEntry {
  key: string;
  href: string;
  scrollTop: number;
}

export type NativeNavigationAction = 'forward' | 'back' | 'root' | 'none';

/** Only entries observed in this mounted customer shell can be swipe destinations. */
export class NativeNavigationHistory {
  entries: NativeNavigationEntry[] = [];
  action: NativeNavigationAction = 'root';

  get current() {
    return this.entries.at(-1);
  }

  get canGoBack() {
    return this.entries.length > 1 && this.entries.every((entry) => isNativeNavigationPage(entry.href));
  }

  visit(key: string, href: string, operation: 'push' | 'replace' | 'pop', root: boolean) {
    const current = this.current;
    const entry = { key, href, scrollTop: 0 };
    const samePage = current && new URL(current.href, 'https://native.invalid').pathname ===
      new URL(href, 'https://native.invalid').pathname;
    const backIndex = this.entries.findIndex((item) => item.key === key);

    if (operation === 'replace' && samePage && current) {
      current.href = href;
      current.key = key;
      this.action = 'none';
    } else if (operation === 'pop' && backIndex >= 0 && backIndex < this.entries.length - 1) {
      this.entries = this.entries.slice(0, backIndex + 1);
      this.action = 'back';
    } else if (!current || root || new URL(href, 'https://native.invalid').pathname === '/' || operation !== 'push' || samePage ||
      !isNativeNavigationPage(href) || !isNativeNavigationPage(current.href)) {
      this.entries = [entry];
      this.action = 'root';
    } else {
      this.entries = [...this.entries, entry].slice(-4);
      this.action = 'forward';
    }
    return this.action;
  }
}
